export const DEFAULT_PAGINATION_PARAMS = {
  order_by: "",
  order_type: "ASC",
  page: 1,
  page_size: 10,
  search: "",
  search_by: "",
};

export const DEFAULT_DASHBOARD_PARAMS = {};
